export default __webpack_public_path__ + "static/media/4452-revolverx.858b200e.pdf";